import React from 'react';
import Menu from '../../components/typography/Menu';

function DesktopMenuText({children}: {children: React.ReactNode}) {
    return (
        <Menu sx={{
            '@media (min-width: 1200px)': {
                lineHeight: 2,
            },
        }}>
            {children}
        </Menu>
    );
}

export default DesktopMenuText;
